export const SKIP_UPDATE = Symbol("skip-update");
//# sourceMappingURL=SKIP_UPDATE.js.map